<template>
  <v-card tile v-if="showBanner.active" dark color="primary" elevation="0">
    <div>
      <v-card-text class="mr-2">
        {{
          $t(
            "components.banners.pinBanner.pleaseUseThisActivationCodeInTheMobileAppToActivateTheBoatMonitorDeviceAndStartItsSubscriptionPlan",
            {
              mobileAppName:
                getTheme.id === "beneteau" ? "Seanapps" : "Sentinel",
            }
          )
        }}
      </v-card-text>
      <v-card-text class="mr-2 pt-0">
        <strong>{{ showBanner.pin }}</strong>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    showBanner: {
      type: Object,
      default: Object,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(["getTheme"]),
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
